import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const usePromoCode = () => {
  const [loading, setLoading] = useState(false);

  const redeemPromoCode = async (code: string) => {
    if (!code.trim()) {
      toast.error('Please enter a promo code');
      return { success: false, error: 'Promo code is required' };
    }

    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('redeem-promo-code', {
        body: { code: code.trim().toUpperCase() }
      });

      if (error) throw error;

      if (data.success) {
        toast.success(data.message || 'Promo code redeemed successfully!');
        return { success: true, subscription_tier: data.subscription_tier };
      } else {
        toast.error(data.error || 'Failed to redeem promo code');
        return { success: false, error: data.error };
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'An error occurred';
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    redeemPromoCode,
    loading
  };
};